import { gql } from '@apollo/client';

import { TRANSACTION_FRAGMENT } from '../fragments';

export const TRANSACTIONS = gql`
  ${TRANSACTION_FRAGMENT}
  query transactions(
    $size: Int
    $accountId: String
    $subaccountId: String
    $time: TransactionTime
    $cursor: String
  ) {
    transactions(
      input: {
        size: $size
        accountId: $accountId
        subaccountId: $subaccountId
        time: $time
        cursor: $cursor
      }
    ) {
      elements {
        ...TransactionFragment
      }
      size
      nextCursor
    }
  }
`;
